import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { LoanDto } from "@src/api-new/generated-api.schemas";

interface CreditHistoryState {
  loading?: boolean;
  loanHistory?: LoanDto[];
  paymentHistoryDocsLoading?: boolean;
}

const initialState: CreditHistoryState = {};

const creditHistorySlice = createSlice({
  name: "creditHistory",
  initialState,
  reducers: {
    loanHistoryRequested(state) {
      state.loading = true;
    },
    loanHistorySucceeded(state, action: PayloadAction<LoanDto[]>) {
      state.loanHistory = action.payload;
      state.loading = false;
    },
    loanHistoryFailed(state) {
      state.loanHistory = undefined;
      state.loading = false;
    },
    paymentHistoryDocsRequested(state, action: PayloadAction<number[]>) {
      state.paymentHistoryDocsLoading = true;
    },
    paymentHistoryDocsSucceeded(state) {
      state.paymentHistoryDocsLoading = false;
    },
    paymentHistoryDocsFailed(state) {
      state.paymentHistoryDocsLoading = false;
    },
    destroy() {
      return initialState;
    }
  }
});

export default creditHistorySlice.reducer;
export const {
  loanHistoryRequested,
  loanHistorySucceeded,
  loanHistoryFailed,
  paymentHistoryDocsRequested,
  paymentHistoryDocsSucceeded,
  paymentHistoryDocsFailed,
  destroy
} = creditHistorySlice.actions;
export const creditHistoryActions = creditHistorySlice.actions;
